/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LoanConfigurationDto } from './LoanConfigurationDto';
import {
    LoanConfigurationDtoFromJSON,
    LoanConfigurationDtoFromJSONTyped,
    LoanConfigurationDtoToJSON,
    LoanConfigurationDtoToJSONTyped,
} from './LoanConfigurationDto';
import type { BorrowerDto } from './BorrowerDto';
import {
    BorrowerDtoFromJSON,
    BorrowerDtoFromJSONTyped,
    BorrowerDtoToJSON,
    BorrowerDtoToJSONTyped,
} from './BorrowerDto';

/**
 * Complete borrower information with associated loan configurations
 * @export
 * @interface InsuredWithLoansDto
 */
export interface InsuredWithLoansDto {
    /**
     * 
     * @type {BorrowerDto}
     * @memberof InsuredWithLoansDto
     */
    insured: BorrowerDto;
    /**
     * List of loan configurations associated with the insured person
     * @type {Array<LoanConfigurationDto>}
     * @memberof InsuredWithLoansDto
     */
    loanConfigurations: Array<LoanConfigurationDto>;
}

/**
 * Check if a given object implements the InsuredWithLoansDto interface.
 */
export function instanceOfInsuredWithLoansDto(value: object): value is InsuredWithLoansDto {
    if (!('insured' in value) || value['insured'] === undefined) return false;
    if (!('loanConfigurations' in value) || value['loanConfigurations'] === undefined) return false;
    return true;
}

export function InsuredWithLoansDtoFromJSON(json: any): InsuredWithLoansDto {
    return InsuredWithLoansDtoFromJSONTyped(json, false);
}

export function InsuredWithLoansDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InsuredWithLoansDto {
    if (json == null) {
        return json;
    }
    return {
        
        'insured': BorrowerDtoFromJSON(json['insured']),
        'loanConfigurations': ((json['loanConfigurations'] as Array<any>).map(LoanConfigurationDtoFromJSON)),
    };
}

export function InsuredWithLoansDtoToJSON(json: any): InsuredWithLoansDto {
    return InsuredWithLoansDtoToJSONTyped(json, false);
}

export function InsuredWithLoansDtoToJSONTyped(value?: InsuredWithLoansDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'insured': BorrowerDtoToJSON(value['insured']),
        'loanConfigurations': ((value['loanConfigurations'] as Array<any>).map(LoanConfigurationDtoToJSON)),
    };
}

